import { render, staticRenderFns } from "./People.vue?vue&type=template&id=38eb65e7&scoped=true&"
import script from "./People.vue?vue&type=script&lang=tsx&"
export * from "./People.vue?vue&type=script&lang=tsx&"
import style0 from "./People.vue?vue&type=style&index=0&id=38eb65e7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb65e7",
  null
  
)

export default component.exports